import request from '../axios';

export const createPatient = (
  therapist_id: number,
  name: string,
  lastname: string,
  email: string,
  type: number,
  birthdate: string,
  gender: string,
  maritalStatus: string
) =>
  request.post('/api/patient/create', {
    therapist_id,
    name,
    lastname,
    email,
    type,
    birthdate,

    gender,
    maritalStatus,
  });

export const invitePatient = (
  therapist_id: number,
  name: string,
  lastname: string,
  email: string,
  type: number
) =>
  request.post('/api/patient/invite', {
    therapist_id,
    name,
    lastname,
    email,
    type,
  });

export const getAllPatientsByTherapist = (therapist_id: number) =>
  request.get(`/api/patient/therapist/${therapist_id}`);

export const getPatient = (patient_id: string) =>
  request.get(`/api/patient/${patient_id}`);
export const updatePatientInfo = (patient_id: string, data: any) =>
  request.put(`/api/patient/${patient_id}`, { data });
export const sendPatientQuest = (
  patient_id: string,
  therapist_id: string,
  questionnaries: any
) =>
  request.post(`/api/patient/${patient_id}/questionnaires`, {
    therapist_id,
    questionnaries,
  });

export const getPatientAutoregistry = (
  patient_id: string,
  from: string,
  to: string
) =>
  request.get(`/api/patient/${patient_id}/autoregistry?from=${from}&to=${to}`);
export const sendPatientAutoregistry = (
  patient_id: string,
  therapist_id: string,
  name: string,
  questions: string[]
) =>
  request.post(`/api/patient/${patient_id}/autoregistry`, {
    therapist_id,
    name,
    questions,
  });
export const getAutoregistryMonthDots = (
  patient_id: string,
  from: string,
  to: string
) =>
  request.get(
    `/api/patient/${patient_id}/autoregistry/calendar?from=${from}&to=${to}`
  );
export const getDiaryMonthDots = (
  patient_id: string,
  from: string,
  to: string
) =>
  request.get(
    `/api/patient/${patient_id}/diary/calendar?from=${from}&to=${to}`
  );
export const getPatientDairies = (
  patient_id: string,
  from: string,
  to: string
) => request.get(`/api/patient/${patient_id}/diary?from=${from}&to=${to}`);
export const getPatientEmotionalTrack = (
  patient_id: string,
  from: string,
  to: string
) => request.get(`/api/patient/${patient_id}/emotional?from=${from}&to=${to}`);
export const sendNote = (patient_id: string, data: FormData) =>
  request.post(`/api/patient/${patient_id}/notes`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
export const getNotes = (patient_id: string) =>
  request.get(`/api/patient/${patient_id}/notes`);
export const startTranscription = (audio_id: string) =>
  request.get(`/api/audio/${audio_id}/transcriptions`);

export const getChangesHistory = (patient_id: string) =>
  request.get(`/api/patient/${patient_id}/changes-history`);
export const sendChangeHistory = (
  patient_id: string,
  title: string,
  description: string
) =>
  request.post(`/api/patient/${patient_id}/changes-history`, {
    title,
    description,
  });

export const getInformedConsent = (patient_id: string) =>
  request.get(`/api/patient/${patient_id}/informed-consent`);
export const getOtherDocumentation = (patient_id: string) =>
  request.get(`/api/patient/${patient_id}/documentation`);
export const deleteDocumentation = (patient_id: string, path: string) =>
  request.post(`/api/patient/${patient_id}/documentation/delete`, { path });

export const sendResource = (patient_id: string, data: FormData) =>
  request.post(`/api/patient/${patient_id}/resources`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
export const removeResource = (
  patient_id: string,
  path: string,
  type: string
) =>
  request.post(`/api/patient/${patient_id}/resources/delete`, { path, type });
export const assignResourceToPatient = (patient_id: string, resources: any[]) =>
  request.post(`/api/patient/${patient_id}/resources/assign`, { resources });

export const getAutoregistryTemplates = () =>
  request.get('/api/autoregistry/template');

export const createAutoregistryTemplate = (
  name: string,
  questions: string[],
  default_time?: string
) =>
  request.post('/api/autoregistry/template', {
    name,
    questions,
    default_time,
  });

export const updateAutoregistryTemplate = (
  id: string,
  name: string,
  questions: string[],
  default_time?: string
) =>
  request.put('/api/autoregistry/template', {
    id,
    name,
    questions,
    default_time,
  });

export const deleteAutoregistryTemplate = (id: string) =>
  request.delete(`/api/autoregistry/template?id=${id}`);

// Schedule-related service functions
export const getScheduledAutoregisters = async (patientId: string) => {
  try {
    const response = await request.get(
      `/api/autoregistry/schedule?patient_id=${patientId}`
    );

    if (!response) {
      throw new Error('Failed to fetch scheduled autoregisters');
    }

    return response.data;
  } catch (error) {
    console.error('Error fetching scheduled autoregisters:', error);
    throw error;
  }
};

export const createScheduledAutoregister = async (
  name: string,
  questions: any[],
  patient_id: string,
  therapist_id: string,
  schedule_type: 'daily' | 'weekly' | 'monthly',
  schedule_time: string,
  schedule_day?: number,
  timezone?: string
) => {
  try {
    const response = await request.post('/api/autoregistry/schedule', {
      name,
      questions,
      patient_id,
      therapist_id,
      schedule_type,
      schedule_time,
      schedule_day,
      timezone: timezone || 'UTC',
    });

    if (!response) {
      throw new Error('Failed to create scheduled autoregister');
    }

    return response.data;
  } catch (error) {
    console.error('Error creating scheduled autoregister:', error);
    throw error;
  }
};

export const updateScheduledAutoregister = async (
  id: string,
  name?: string,
  questions?: any[],
  schedule_type?: 'daily' | 'weekly' | 'monthly',
  schedule_time?: string,
  schedule_day?: number,
  timezone?: string,
  active?: boolean
) => {
  try {
    const response = await request.put('/api/autoregistry/schedule', {
      id,
      name,
      questions,
      schedule_type,
      schedule_time,
      schedule_day,
      timezone,
      active,
    });

    if (!response) {
      throw new Error('Failed to update scheduled autoregister');
    }

    return response.data;
  } catch (error) {
    console.error('Error updating scheduled autoregister:', error);
    throw error;
  }
};

export const deleteScheduledAutoregister = async (id: string) => {
  try {
    const response = await request.delete(
      `/api/autoregistry/schedule?id=${id}`
    );

    if (!response) {
      throw new Error('Failed to delete scheduled autoregister');
    }

    return response.data;
  } catch (error) {
    console.error('Error deleting scheduled autoregister:', error);
    throw error;
  }
};
